import parsePhoneNumberFromString, {
  type CountryCode,
} from "libphonenumber-js";

/**
 * Normalizes a national or partial number to E.164 when possible.
 */
export default function normalizePhoneNumber(
  phoneNumber: string,
  marketCode: string,
): string {
  const trimmed = phoneNumber.trim();
  if (!trimmed) return trimmed;

  const parsed = parsePhoneNumberFromString(
    trimmed,
    marketCode.toUpperCase() as CountryCode,
  );

  if (parsed?.isValid()) {
    return parsed.format("E.164");
  }

  return trimmed;
}
